import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';

import uploadIcon from 'core/assets/svg/upload-icon.svg';
import Button from 'core/components/button/button';
import { Label } from 'core/components/label';
import { useStore } from 'core/store';
import OfferDocumentModal from './offer-document-modal';

const SupportingDocumentsButton = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { offer: store } = useStore();

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  if (store.loading) {
    return <></>;
  }

  return (
    <>
      <Grid container direction="row" alignItems="center" spacing={2} justifyContent="flex-end">
        <Grid item>
          <Button color="secondary" onClick={handleOpenModal} disabled={!store.offer?.webUserId}>
            <Grid container item alignItems="center">
              <img src={uploadIcon} alt="upload" />
              Supporting Documents
            </Grid>
          </Button>
        </Grid>
        <Grid item>
          <Label type="infoLabel">{store.documentCountDisplay}</Label>
        </Grid>
      </Grid>

      <OfferDocumentModal open={modalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default observer(SupportingDocumentsButton);
